export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8068.a45e0b77.jpg";